import React from 'react';
import TableInc from '../../../../../shared-ui/TableInc';
import { updateExtendedConfig } from "../../../../../lib/requests.es6";

const Benefits = ({ benefits, productGuid, extendedConfig }) => {
  const saveBenefits = (updatedBenefits) => {
    const membershipConfig = {
      product_guid: productGuid,
      ...extendedConfig,
      content: {
        ...extendedConfig.content,
        benefits: updatedBenefits,
      },
    };

    return updateExtendedConfig(membershipConfig);
  };

  return (
    <TableInc
      title="Benefits"
      columns={[
        { title: 'Benefit Name', field: 'name' },
        { title: 'Limit', field: 'limit' },
      ]}
      data={benefits}
      options={{
        showTitle: true,
        pageSize: benefits.length,
        actionsColumnIndex: -1,
        addRowPosition: 'first',
      }}
      editable={{
        onRowAdd: (newData) =>
          new Promise((resolve, reject) => {
            const updatedBenefits = [...benefits, newData];
            saveBenefits(updatedBenefits)
              .then((response) => {
                console.log('Benefits updated:', response);
                resolve();
              })
              .catch((error) => {
                console.error('Error updating benefits:', error);
                reject();
              });
          }),
        onRowDelete: (oldData) =>
          new Promise((resolve, reject) => {
            const updatedBenefits = benefits.filter((benefit) => benefit !== oldData);
            saveBenefits(updatedBenefits)
              .then((response) => {
                console.log('Benefits updated:', response);
                resolve();
              })
              .catch((error) => {
                console.error('Error updating benefits:', error);
                reject();
              });
          }),
      }}
    />
  );
};

export default Benefits;